module.exports = __webpack_public_path__ + "static/media/videoCamera.e6062cd7.svg";